export enum PieChartAggregationStrategy {
  AVERAGE = 'AVERAGE',
  LATEST = 'LATEST'
}
